export default __webpack_public_path__ + "d28272a3a56005713757ff3dec77fdb3.jpg";